export const openChat = () => {
    window.fcWidget?.open()
}
